module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione5 b.5dbdaef2.svg";